module.exports = __webpack_public_path__ + "media/images/c-checkbox/check-de828ac70be4b77f295d05cc5d0decca.svg";